import { render, staticRenderFns } from "./template-bulk-expenditures.vue?vue&type=template&id=aa77b68c&"
import script from "./template-bulk-expenditures.vue?vue&type=script&lang=js&"
export * from "./template-bulk-expenditures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports